<div class="page-bg">
  <div class="container pt-2 pb-2">
    <mat-card>
      <mat-card-header>
        <mat-card-title class="m-0 mb-1">Registration Success</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <mat-icon class="icon-info">insert_emoticon</mat-icon>
        <div class="d-inline-block ml-2">
          The registration was correct.<br />
          A message was sent to the email address provided.<br />
          To activate your account, please click on the sent activation link.
        </div>
      </mat-card-content>
    </mat-card>
  </div>
</div>
